var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigiArsMenuIconFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "hmim-svg",
    width: 22,
    height: 22,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41173_3385)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29492 6.63281C2.29492 4.94198 3.66561 3.57129 5.35645 3.57129H19.6436C21.3344 3.57129 22.7051 4.94198 22.7051 6.63281V20.9199C22.7051 22.6108 21.3344 23.9814 19.6436 23.9814H5.35645C3.66561 23.9814 2.29492 22.6108 2.29492 20.9199V6.63281Z",
    fill: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.582 1.53027C17.1456 1.53027 17.6025 1.98717 17.6025 2.55078V6.63281C17.6025 7.19642 17.1456 7.65332 16.582 7.65332C16.0184 7.65332 15.5615 7.19642 15.5615 6.63281V2.55078C15.5615 1.98717 16.0184 1.53027 16.582 1.53027Z",
    fill: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41797 1.53027C8.98158 1.53027 9.43848 1.98717 9.43848 2.55078V6.63281C9.43848 7.19642 8.98158 7.65332 8.41797 7.65332C7.85436 7.65332 7.39746 7.19642 7.39746 6.63281V2.55078C7.39746 1.98717 7.85436 1.53027 8.41797 1.53027Z",
    fill: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29492 10.7148C2.29492 10.1512 2.75182 9.69434 3.31543 9.69434H21.6846C22.2482 9.69434 22.7051 10.1512 22.7051 10.7148C22.7051 11.2785 22.2482 11.7354 21.6846 11.7354H3.31543C2.75182 11.7354 2.29492 11.2785 2.29492 10.7148Z",
    fill: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-white",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.35156 10.7148C1.35156 10.1512 1.80846 9.69434 2.37207 9.69434H22.8475C23.4111 9.69434 23.868 10.1512 23.868 10.7148C23.868 11.2785 23.4111 11.7354 22.8475 11.7354H2.37207C1.80846 11.7354 1.35156 11.2785 1.35156 10.7148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15039 19.8229L11.5167 15.5388L13.8628 17.1703L16.9231 13.957",
    stroke: "white",
    strokeWidth: 1.67442,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41173_3385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.201904)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigiArsMenuIconFilled);
export default __webpack_public_path__ + "static/media/DigiArsMenuIconFilled.9cbf3f04ccf3390788f50c73bcdd82e4.svg";
export { ForwardRef as ReactComponent };